export default "__VITE_ASSET__CuSRmWGF__"